import {
  UNVERIFIED_BOOKING_HINT,
  UNVERIFIED_BOOKING_STYLE,
  isUnverifiedBooking,
} from "./appointmentViewShared";

/** "Unverified" pill for BookMyDentist guest bookings; renders nothing otherwise. */
export default function UnverifiedBookingBadge({
  item,
  className = "",
}: {
  item: any;
  className?: string;
}) {
  if (!isUnverifiedBooking(item)) return null;
  return (
    <span
      className={`inline-flex shrink-0 items-center rounded-md border px-1.5 py-0.5 text-[10px] font-semibold ${UNVERIFIED_BOOKING_STYLE} ${className}`}
      title={UNVERIFIED_BOOKING_HINT}
    >
      Unverified
    </span>
  );
}
